// extracted by mini-css-extract-plugin
export default {"root":"SbatGroupFilterChips_root__XnyMm"};